import React, { memo } from 'react';

/**
 * Domain name popup shown on long-press of the .com key.
 * Pure UI — no Redux, no state.
 */
const DomainPicker = memo(({ domains, onSelect }) => {
  if (!domains?.length) return null;

  return (
    <div
      style={{
        position: 'absolute',
        right: '3%',
        bottom: '26%',
        background: '#fff',
        border: '1px solid #ccc',
        zIndex: 999,
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: '4px',
        padding: '4px',
        overflowY: 'auto',
      }}
    >
      {domains.map(domain => (
        <div
          key={domain}
          onClick={() => onSelect(domain)}
          style={{
            cursor: 'pointer',
            padding: '8px 4px',
            textAlign: 'center',
            border: '1px solid #eee',
            borderRadius: '4px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
          className="fs-30"
        >
          {domain}
        </div>
      ))}
    </div>
  );
});

DomainPicker.displayName = 'DomainPicker';

export default DomainPicker;
